import React from "react";

const DirectSubmitReport = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      className="study-list-report-icons"
    >
      <path d="M12.9525 5.0475L9.7725 12.645L8.5425 9.4575L7.9275 9.2175L5.355 8.22L12.9525 5.0475ZM15.75 2.25L2.25 7.8975V8.6325L7.38 10.62L9.36 15.75H10.095L15.75 2.25Z" />
    </svg>
  );
};

export default DirectSubmitReport;
